export default ({ request }) => ({
  shipmentPayStatementListApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/list',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementShareListApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/shareList',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementDetailApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/detail',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementSaveApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/save',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementDelApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/del',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementCopyApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/copy',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementSubmitReviewApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/submitReview',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementReviewApprovedApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/reviewApproved',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementRejectReviewApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/rejectReview',
      method: 'post',
      data,
    })
  },
  shipmentPayStatementBookingOptionalApi(data = {}) {
    return request({
      url: '/factory/shipment/pay/statement/bookingOptional',
      method: 'post',
      data,
    })
  },
})
